import * as React from "react"
import { useExportTransactionsLazyQuery } from "@digits-graphql/frontend/graphql-bearer"
import { SvgAlertTriangleSolid } from "@digits-shared/components/SVGIcons/solid/AlertTriangleSolid.svg"
import { SvgCheckCircleSolid } from "@digits-shared/components/SVGIcons/solid/CheckCircleSolid.svg"
import useRouter from "@digits-shared/hooks/useRouter"
import {
  type ExportPropsWithoutToVault,
  useExportVariables,
} from "src/frontend/components/OS/Applications/Shared/Accounting/Exports/hooks/useExportVariables"
import { useChromeAlertContext } from "src/frontend/components/Shared/Alerts/ChromeAlertsContext"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"
import routes from "src/frontend/routes"

export function useExportToVault(props: ExportPropsWithoutToVault) {
  const variables = useExportVariables({ ...props, toVault: true })
  const { history } = useRouter()
  const { addAlert } = useChromeAlertContext()
  const pathGenerator = useFrontendPathGenerator()
  const [exportToVault] = useExportTransactionsLazyQuery()

  return React.useCallback(() => {
    exportToVault({
      variables,
      fetchPolicy: "no-cache",
    })
      .then((res) => {
        addAlert({
          id: "vault-export-complete",
          message: "Export complete",
          SVGComponent: SvgCheckCircleSolid,
          autoDismiss: true,
          buttonText: "View in Vault",
          onClick: () =>
            history.push(
              pathGenerator(routes.vaultFile, {
                fileId: res.data?.exportTransactions.documentId || "",
              })
            ),
        })
      })
      .catch(() => {
        addAlert({
          id: "vault-export-error",
          message: "Unable to export to Vault",
          SVGComponent: SvgAlertTriangleSolid,
          autoDismiss: true,
        })
      })
  }, [addAlert, exportToVault, history, pathGenerator, variables])
}
